import { createAction } from '@reduxjs/toolkit';
import * as itemTypes from '../../../items/item-types';
import {
  getItem as getItemInternal,
  saveItem as saveItemInternal
} from '../../../items/item.actions';
import { keyFromItemType } from '../../../routing-utils';

export const receiveAdCreative = createAction('receiveAdCreative');
export const setAdCreativeIsBusy = createAction('setAdCreativeIsBusy');
export const modifyAdCreative = createAction('modifyAdCreative');
export const closeAdCreative = createAction('closeAdCreative');

const adCreativeModel = (id, name, params) => {
  return {
    id,
    name,
    type: itemTypes.AD_CREATIVE,
    [keyFromItemType(itemTypes.CAMPAIGN)]: params.campaignid
  };
};

const ALT_TEXT_REQUIREMENTS = [
  {
    idField: 'thumbnailImageId',
    altField: 'thumbnailAltText',
    label: 'thumbnail'
  },
  {
    idField: 'squareImageId',
    altField: 'squareImageAltText',
    label: 'square'
  },
  {
    idField: 'portraitImageId',
    altField: 'portraitImageAltText',
    label: 'portrait'
  }
];

export const getItem = getItemInternal(
  adCreativeModel,
  receiveAdCreative,
  setAdCreativeIsBusy
);

export const saveItem = saveItemInternal(modifyAdCreative, item => {
  const altTextMissing = ALT_TEXT_REQUIREMENTS.find(
    ({ idField, altField }) => item[idField] && !item[altField]?.trim()
  );
  if (altTextMissing) {
    return `Alt text is required for the ${altTextMissing.label} image.`;
  }
});
